const caret = `<svg viewBox="0 0 8 16"><path d="M7.5 8l-5 5L1 11.5 4.75 8 1 4.5 2.5 3z"/></svg>`
export default caret
